/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ResponseApiS3ShangChuanLinShiAnQuanPingJuXiangYing,
  S3ShangChuanLinShiPingJuQingQiu,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class S3CunChu<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags S3CunChu
   * @name GetUploadCredentialUsingPost
   * @summary 获取 S3 上传临时安全凭据（token）
   * @request POST:/dsp-admin/api/s3/upload-credential
   * @secure
   */
  getUploadCredentialUsingPost = (
    request: S3ShangChuanLinShiPingJuQingQiu,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiS3ShangChuanLinShiAnQuanPingJuXiangYing, void>({
      path: `/dsp-admin/api/s3/upload-credential`,
      method: "POST",
      body: request,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new S3CunChu();
